import { TextAlignType } from '@/version-types';

export const MIN_BASE_CELL_WIDTH = 20;
export const MIN_BASE_CELL_HEIGHT = 20;
export const MIN_BORDER_WIDTH = 2;
export const TABLE_CELL_HORIZONTAL_PADDING = 4;
export const DEFAULT_TABLE_CELL__BACKGROUND_COLOR = '#ffffffff';
export const DEFAULT_TABLE_CELL__VERTICAL_ALIGN = 'center';
/**
 * 历史遗留问题, 旧数据的表格才有可能不带fontSize, 旧逻辑: 用户不修改fontSize时, 默认就是不带fontSize的, 取的DEFAULT_TABLE_CELL__TEXT_FONT_SIZE
 * 新添加的表格一定是带fontSize的
 * 为什么一定要带: 不带的话, 智能缩放就不会去缩放fontSize
 */
export const DEFAULT_TABLE_CELL__TEXT_FONT_SIZE = 40;
export const DEFAULT_TABLE_CELL__TEXT_COLOR = '#000000ff';
export const DEFAULT_TABLE_CELL__TEXT_ALIGN = TextAlignType.CENTER;
export const DEFAULT_TABLE_CELL__LINE_HEIGHT = 1.2;

// tableController相关config
/** 最边缘的bar的粗细 */
export const SIDE_BAR_BOLD = 16;
export const MAX_ROW_COUNT = 100;
export const MAX_COL_COUNT = 20;
/** 鼠标可悬浮区域的粗细 (粗一点, 比较方便鼠标能移动到) */
export const LINE_HOVER_BOLD = 6;
/** 实际显示粗细 */
export const LINE_BOLD = 1;
